import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable, PLATFORM_ID, signal } from '@angular/core';
import { catchError, map, Observable, retry, throwError } from 'rxjs';
import { OrderAdapter } from '../adapters/order.adapter';
import { ApplicationLog, CloseReason, OrderResponseApi, OrderType } from '../interfaces/orden.interface';
import { Log } from '../interfaces/log.interface';
import { isPlatformServer } from '@angular/common';
import { v4 as uuidv4 } from 'uuid';
import { environment } from '../../../environments/environment';
import { CLOSE_MESSAGES } from '../constants/messages.contants';

// Nueva forma de tipar el alcance global usando globalThis
declare global {
  var ANDROID: {// NOSONAR
    getPaymentEvent: (payload: string) => void;
  } | undefined;

  var webkit: {// NOSONAR
    messageHandlers?: {
      IOS?: {
        postMessage: (payload: string) => void;
      };
    };
  } | undefined;
}
@Injectable({
  providedIn: 'root'
})
export class OrderService {
  private readonly _http = inject(HttpClient)
  private readonly platformId = inject(PLATFORM_ID)
  uuid!: string

  $total = signal<number>(0);

  constructor() {
    if (isPlatformServer(this.platformId)) {
      this.uuid = uuidv4().replaceAll('-', '')
    }
  }

  getOrder(orderId: string): Observable<OrderType> {
    return this._http.get<OrderResponseApi>(`${environment.orderApi}/paynow/app/v1/payment/order/${orderId}/angular/get`).pipe(
      map((response) => OrderAdapter(response, orderId)),
      retry(3),
      catchError(this.handleError)
    )
  }

  private handleError(error: HttpErrorResponse) {
    const responseError = {
      title: error.error?.message ? 'Información no encontrada' : 'Error en el servicio',
      message: 'Ocurrio un error al establecer la conexión con el servidor. Por favor intentalo más tarde.',
      success: false,
      ...error.error,
    }
    return throwError(() => responseError);
  }

  createLog(logData: Log) {
    console.log(`${this.formatedDate} | Pagos Web | ${this.uuid} | ${logData.process} | ${JSON.stringify(logData.request)} | ${JSON.stringify(logData.response)}`)
  }

  get formatedDate() {
    const date = new Date()
    const yyyy = date.getFullYear();
    const MM = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const HH = String(date.getHours()).padStart(2, '0');
    const mm = String(date.getMinutes()).padStart(2, '0');
    const ss = String(date.getSeconds()).padStart(2, '0');

    return `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}`;
  }

  createApplicationLog(event: ApplicationLog) {
    const payload = {
      date: this.formatedDate,
      prefix: event.prefix,
      uuid: this.uuid,
      event: {
        ...event,
        platform: this.getPlatform()
      }
    };

    if (this.isAndroidWebView()) {
      globalThis.ANDROID!.getPaymentEvent(JSON.stringify(payload));
      return;
    }

    if (this.isIOSWebView()) {
      globalThis?.webkit!.messageHandlers!.IOS!.postMessage(JSON.stringify(payload));
      return;
    }
  }

  private getPlatform(): string {
    if (this.isAndroidWebView()) return 'ANDROID';
    if (this.isIOSWebView()) return 'IOS';
    return 'WEB';
  }

  private isAndroidWebView(): boolean {
    return typeof globalThis !== 'undefined' &&
      typeof globalThis.ANDROID?.getPaymentEvent === 'function';
  }

  private isIOSWebView(): boolean {
    return typeof globalThis !== 'undefined' &&
      typeof globalThis.webkit?.messageHandlers?.IOS?.postMessage === 'function';
  }

  closeWebView(prefix: string, reason: CloseReason) {
    this.createApplicationLog({
      prefix,
      event: {
        event: 'CloseWebView',
        reason,
        message: CLOSE_MESSAGES[reason]
      }
    });
  }
}
